import $ from 'jquery';
import { debounce } from 'lodash';

export default class StickySubHeader {
  /**
   * @param {string} subHeaderSelector
   * @param {string} headerSelector
   */
  constructor(subHeaderSelector, headerSelector) {
    this.$window = $(window);
    this.$header = $(headerSelector);
    this.$subHeader = $(subHeaderSelector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$subHeader.length) {
      this.isInitialized = false;

      return;
    }

    this.checkState();

    this.$window.scroll(debounce(() => this.checkState(), 300));

    this.$window.resize(this.tweakOffset());
  }

  checkState() {
    const headerHeight = this.$header.height();

    if (this.$window.scrollTop() >= (this.$subHeader.offset().top - headerHeight)) {
      this.stuck(headerHeight);
    } else {
      this.unstuck();
    }
  }

  tweakOffset() {
    return debounce(() => this.updateOffset(this.$header.height()), 300);
  }

  stuck(offset) {
    this.$subHeader.addClass('is-stuck');
    this.$subHeader.css('top', offset);
  }

  unstuck() {
    this.$subHeader.removeClass('is-stuck');
  }

  updateOffset(offset) {
    this.$subHeader.css('top', offset);
  }
}
